
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.event-detail {width: 100%;overflow: hidden;border-radius: 0.5rem;border-width: 1px;border-style: solid;border-color: var(--bh-neutral-default)
}@media (min-width: 1024px) {.event-detail {display: flex
    }
}

.content {padding: 2rem
}

@media (min-width: 1024px) {.content {display: flex
    }.content {width: 100%
    }
}

::slotted([slot='date']) {display: flex;flex-direction: column;justify-content: center;padding: 2rem;text-align: center;font-family: var(--bh-ff-body);text-transform: uppercase;color: var(--bh-neutral-white)
}

@media (min-width: 1024px) {:host([sections='3']) ::slotted([slot='time']), :host([sections='3']) ::slotted([slot='location']), :host([sections='3']) ::slotted([slot='payment']) {flex-basis: 33.333333%
    }
}

@media (min-width: 1024px) {:host([sections='2']) ::slotted([slot='time']), :host([sections='2']) ::slotted([slot='location']), :host([sections='2']) ::slotted([slot='payment']) {flex-basis: 50%
    }
}

::slotted([slot='date']) {background-color: var(--bh-brand-primary-default)
}

::slotted([slot='time']), ::slotted([slot='location']) {display: block;border-style: solid;border-color: var(--bh-neutral-default)
}

@media (min-width: 1024px) {::slotted([slot='time']), ::slotted([slot='location']) {border-right-width: 1px
    }::slotted([slot='location']) {min-width: 230px
    }
}

.content ::slotted([slot]) {padding-top: 1rem;padding-bottom: 1rem
}

@media (min-width: 1024px) {.content ::slotted([slot]) {padding-top: 0px;padding-bottom: 0px
    }
}

.content .cards {padding-left: 2rem;padding-right: 2rem
}
`;